import { useState } from 'react';
import { appData } from '@/mocks/home';

export default function AppSection() {
  const [imgError, setImgError] = useState(false);

  return (
    <section id="app" className="w-full px-4 md:px-6 lg:px-10 py-10 md:py-14">
      <div className="w-full">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-1.5 h-7 rounded-full bg-secondary-500" />
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950">手机看视频</h2>
        </div>

        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-14 rounded-2xl border border-background-200/70 bg-background-50 p-6 md:p-10 lg:p-12">
          <div className="flex-1 w-full order-2 md:order-1">
            <span className="inline-block px-3 py-1 text-xs font-medium bg-secondary-100 text-secondary-800 rounded-full mb-4">
              {appData.badge}
            </span>
            <h3 className="text-xl md:text-2xl lg:text-3xl font-bold text-foreground-950 mb-4">
              {appData.title}
            </h3>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-lg">
              {appData.desc}
            </p>

            <div className="grid grid-cols-2 gap-4 mb-8">
              {appData.features.map((feat, i) => (
                <div key={i} className="flex items-center gap-3 p-3 rounded-xl bg-background-100">
                  <div className="w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center shrink-0">
                    <div className="w-4 h-4 flex items-center justify-center text-accent-700">
                      <i className="ri-check-line" />
                    </div>
                  </div>
                  <span className="text-sm font-medium text-foreground-800">{feat}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <button
                type="button"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-foreground-950 text-background-50 text-sm font-medium rounded-lg hover:bg-foreground-800 transition-colors whitespace-nowrap"
              >
                <i className="ri-apple-fill text-base" />
                App Store 下载
              </button>
              <button
                type="button"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 border border-background-300/60 text-foreground-700 text-sm font-medium rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap"
              >
                <i className="ri-android-fill text-base" />
                Android 下载
              </button>
            </div>
          </div>

          <div className="w-full max-w-xs md:max-w-sm order-1 md:order-2 shrink-0">
            {!imgError ? (
              <div className="rounded-2xl overflow-hidden bg-background-100 aspect-[2/3]">
                <img
                  src={appData.image}
                  alt="91免费视频网站移动端应用"
                  className="w-full h-full object-cover"
                  onError={() => setImgError(true)}
                />
              </div>
            ) : (
              <div className="rounded-2xl bg-background-100 aspect-[2/3] flex items-center justify-center">
                <div className="text-center">
                  <i className="ri-smartphone-line text-5xl text-foreground-300 mb-3" />
                  <p className="text-sm text-foreground-500">移动端应用</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}